const localState = {
    files: null,
}

const mutations = {
    clear: (state) => {
        state.files = null
    },
    set: (state, v) => {
        state.files = v
    },
}

const actions = {
    async fetch({
        commit,
    }, form) {
        const response = await this.$api.files.fetch(form)
        commit('set', response.data.data || [])
    },
    async add(_, form) {
        try {
            const response = await this.$api.files.add(form)
            return response.status === 200
        } catch (err) {
            // log err
        }
    },
    async remove(_, id) {
        try {
            await this.$api.files.remove(id)
        } catch (err) {
            // log err
        }
    },
}

const getters = {
    files: (state) => state.files,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
